<template>
    <div class="block border border-solid bg-white rounded-xl p-12">
        <h4 class="text-2xl">
            Join The Club
        </h4>
        <p>Get notified when new matches are listed</p>
        <form class="form form--primary" onsubmit="return false;">
            <div class="flex items-end w-full space-x-4">
                <div class="flex-1">
                    <div>
                        First name:
                    </div>
                    <div class="">
                        <input
                            type="text"
                            name="first_name"
                            v-model="formData.firstName"
                            required
                            class="w-full border border-solid border-gray-300 bg-white rounded px-4 py-2"
                            :disabled="submitDisabled"
                        />
                    </div>
                </div>
                <div class="flex-1">
                    <div>
                        Last name:
                    </div>
                    <div class="">
                        <input
                            type="text"
                            name="last_name"
                            v-model="formData.lastName"
                            required
                            class="w-full border border-solid border-gray-300 bg-white rounded px-4 py-2"
                            :disabled="submitDisabled"
                        />
                    </div>
                </div>
                <div class="flex-1">
                    <div>
                        Email:
                    </div>
                    <div class="">
                        <input
                            type="email"
                            name="email"
                            v-model="formData.email"
                            required
                            class="w-full border border-solid border-gray-300 bg-white rounded px-4 py-2"
                            :disabled="submitDisabled"
                        />
                    </div>
                </div>
                <div>
                    <button
                        type="button"
                        class="bg-blue-600 hover:bg-blue-800 text-white py-2 px-6 w-full rounded-md font-medium"
                        @click="submit"
                        :disabled="submitDisabled"
                    >
                        <template v-if="submitDisabled">
                            {{ __("Joined") }}
                        </template>
                        <template v-else>
                            {{ __("Join") }}
                        </template>
                    </button>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
export default {
    name: "newsletter-signup",
    props: {},
    data: function() {
        return {
            formData: {
                firstName: "",
                lastName: "",
                email: ""
            },
            formError: null,
            submitDisabled: false
        };
    },
    methods: {
        submit() {
            this.formError = null;
            if (!this.formData.firstName || !this.formData.lastName || !this.formData.email) {
                this.formError = "Please fill in all fields";
                this.$toasted.show(this.__("Please fill in all fields"), {
                    theme: "bubble",
                    type: "error",
                    position: "top-center",
                    duration: 3000
                });
                return;
            }
            window._klaviyoHelper.recordIdentity({
                $email: this.formData.email,
                $first_name: this.formData.firstName,
                $last_name: this.formData.lastName
            });

            this.submitDisabled = true;

            setTimeout(() => {
                window._klaviyoHelper.recordEvent(["track", "join newsletter", {}]);
            }, 250);

            this.$toasted.show(this.__("Welcome, you will be notified when new matches are listed"), {
                theme: "bubble",
                type: "success",
                position: "top-center",
                duration: 3000
            });
        }
    }
};
</script>
<style lang="scss" scoped>
table {
    margin: 0 auto;
    td {
        padding: 10px;
    }
    select {
        font-size: 18px;
    }
}
.form-error-message {
    text-align: center;
}
.form__error {
    p {
        font-size: 18px;
        font-weight: bold;
    }
}
</style>



// WEBPACK FOOTER //
// resources/js/components/NewsletterSignup.vue